/*
 * Public API Surface of msal-services-v1
 */

export * from './services'
export * from './settings/msal.configuration';
export { MsalGuard as MsalGuardFromService } from './guards/msal.guard';
export * from './msal-services.component';
